import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pap-ready',
  templateUrl: 'pap-ready.component.html',
  styleUrls: ['./pap-ready.component.less', '../../shared/common.less'],
})

export class PapReadyComponent{
  @Output() toPollPlannedEvent = new EventEmitter();
}
